import { useCallback, useEffect } from "react"

import { useUpdatePlaybackTiming } from "../ui/playback-hooks"

/**
 * This hook is intended to inform the server of any changes in playback
 * velocity or discontinuities in playback time. Given this information the
 * server can keep track of the current playback time and thus the client
 * does not need to be sending all timeupdate events to the server.
 *
 * Note that that the moment there is an assumption the playbackrate=1
 */
export const usePlaybackTimingSetup = (
  videoElement: HTMLVideoElement | null,
) => {
  const updatePlaybackTiming = useUpdatePlaybackTiming()

  const onTimingChange = useCallback(
    (event) => {
      if (
        typeof event?.currentTarget?.currentTime === "number" &&
        typeof event?.currentTarget?.paused === "boolean"
      ) {
        const position = event.currentTarget.currentTime * 1000
        const velocity = event.currentTarget.paused ? 0 : 1
        updatePlaybackTiming({ variables: { position, velocity } })
      }
    },
    [videoElement],
  )

  useEffect(() => {
    videoElement?.addEventListener("play", onTimingChange)
    videoElement?.addEventListener("pause", onTimingChange)
    videoElement?.addEventListener("seeked", onTimingChange)
    return () => {
      videoElement?.removeEventListener("play", onTimingChange)
      videoElement?.removeEventListener("pause", onTimingChange)
      videoElement?.removeEventListener("seeked", onTimingChange)
    }
  }, [videoElement, onTimingChange])
}
